import { render, staticRenderFns } from "./PillButton.vue?vue&type=template&id=3d2ed908&scoped=true"
import script from "./PillButton.vue?vue&type=script&lang=js"
export * from "./PillButton.vue?vue&type=script&lang=js"
import style0 from "./PillButton.vue?vue&type=style&index=0&id=3d2ed908&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2ed908",
  null
  
)

export default component.exports